import React, { Component } from 'react';
import Footer from '../Footer/FooterContainer';
import RecommendedTargetAmountChart from '../../RecommendedTargetAmountChart/RecommendedTargetAmountChartContainer';
import FinancialPlanHeader from '../FinancialPlanHeaderView';
import ActionStepsV2 from '../ActionStepsV2/ActionStepsV2Container';
import Explanations from '../Explanations/ExplanationsContainer';
import { ASSUMPTIONS, OVERVIEW } from '../Explanations/ExplanationsConst';
import AssumptionsSectionView from '../Components/AssumptionsTable';
import GeneralAssumptionsView from '../GeneralAssumptions';
import { Tasks } from '../../FinancialPlanOPL/Goals/components/Tasks/Tasks';

export default class LargePurchaseView extends Component {
  render() {
    const {
      clientId,
      largePurchaseGoal,
      fpId,
      data,
      isPrint,
      chartDataPrint,
      showCalibration,
      isCurrentPlan,
      selectedSection,
      largePurchaseAssumptionValues,
      largePurchaseAssumptionLabels,
    } = this.props;

    if (!largePurchaseGoal) {
      return null;
    }

    return (
      <div className="NewFinancialPlan_largePurchase" css="page-break-inside: avoid">
        <div
          className={`NewFinancialPlan_header
            ${!showCalibration ? ' hide-calibration-button' : ''}
          `}
        >
          <FinancialPlanHeader
            {...this.props}
            hideOldDescription={false}
            hideTrackIndicator={selectedSection === ASSUMPTIONS && isPrint}
          />
        </div>
        <section className="calibration" />
        {!isPrint && <Explanations clientId={clientId} />}
        {selectedSection === OVERVIEW && (
          <section className="chart">
            <RecommendedTargetAmountChart
              isPrint={isPrint}
              chartDataPrint={chartDataPrint}
              hasLegend
              title={isCurrentPlan ? 'Savings Schedule' : 'Recommended Savings Schedule'}
              clientId={clientId}
              data={largePurchaseGoal}
              fpId={fpId}
            />
          </section>
        )}
        {selectedSection === ASSUMPTIONS && !isPrint && (
          <div className="assumptions-container">
            <AssumptionsSectionView
              title="Large Purchase Goal Assumptions"
              valuesList={largePurchaseAssumptionValues}
              labelList={largePurchaseAssumptionLabels}
            />
            <br />
            <GeneralAssumptionsView clientId={clientId} />
          </div>
        )}

        {!isPrint && selectedSection !== ASSUMPTIONS && <Tasks />}

        {isPrint && selectedSection !== ASSUMPTIONS && (
          <ActionStepsV2 clientId={clientId} fpId={fpId} goalId={largePurchaseGoal.GoalId} />
        )}

        {!isPrint && <Footer data={data} clientId={clientId} fpId={fpId} />}
      </div>
    );
  }
}
